import styled from 'styled-components';
import media from '../../../components/mediaqueries/media';
const ParentLoginWrapper = styled.div`
height:100%;
.parentLogin {
    background:#f7f7f7 !important;
    height: 1024px;
    text-align: center;
    ${media.mobile`
        height:auto;
    `}
    header{
        padding:50px 0 20px;
        .logo{

        }
    }
    .content{
        .login-block{
            background:#fff;
            padding: 40px;
            max-width: 550px;
            margin: 0 auto;
            ${media.tablet`
            padding: 10px 20px;
             `}
            ${media.mobile`
            padding: 10px 20px;
             `}
            >h1{
                font-family: 'Open Sans', sans-serif;
                font-weight: 500;
                color:#4eb0de;
                font-size: 18px;
                padding:30px 0;
                text-align: center;
            }
            .room-detail{
                background:#f7f7f9;
                padding:20px;
                margin:30px 0 30px;
                border-radius: 10px;
                >h2{
                    font-family: 'Open Sans', sans-serif;
                    font-weight: 500;
                    color:#4eb0de;
                    font-size: 14px;
                    text-align: center;
                    margin:0;
                    padding:0;
                }
                >h3{
                    font-family: 'Open Sans', sans-serif;
                    font-weight: 500;
                    font-size: 24px;
                    font-weight: bold;
                    color:#344177;
                    text-align: center;
                    margin:0;
                    padding:0;
                    ${media.tablet`
                    font-size: 15px;
                    `}
                }
            }
            .tabs-container{
                font-family: 'Open Sans', sans-serif;
                
                .ant-tabs{
                    overflow: visible;
                    .ant-tabs-nav{
                        margin:0 0 20px;
                        &:before{
                            position: absolute;
                            bottom: 7px;
                            border: 0;
                            background: #b2b9d6;
                            height: 1px;
                            width: 100%;
                        }
                        .ant-tabs-nav-list{
                            font-family: 'Open Sans', sans-serif;
                            width: 100%;
                            justify-content: space-between;
                            .ant-tabs-tab{
                                ${media.mobile`
                                `}
                                .ant-tabs-tab-btn{
                                    color:#b2b9d6;
                                    font-size:16px;
                                    font-weight: bold;
                                    ${media.mobile`
                                        font-weight: 600;
                                        font-size:13px;
                                    `}
                                }
                                &.ant-tabs-tab-active{
                                    .ant-tabs-tab-btn{
                                        color: #344177;
                                        font-weight: bold;
                                    }
                                }
                            }
                            .ant-tabs-ink-bar {
                                background: #4eb0de;
                                height:7px;
                             }
                        }
                    }
                }
                
            }
            .formRow{
                text-align: center;
                margin-bottom:10px;
                .ant-picker-input{
                    >input{
                        color:#000 !important;
                    }
                }
                .textbox{
                    font-family: 'Open Sans', sans-serif;
                    border: 1px solid #b2b9d6;
                    background: #fff;
                    padding: 8px;
                    width:75%;
                    border-radius: 4px;
                    flex-basis: 48%;
                    color: #000000;
                    .ant-picker-clear, .ant-picker-suffix{
                        display:none;
                    }
                    &:focus{
                        outline: none;
                    }
                    ::-webkit-input-placeholder {
                        color: #b2b9d6;
                        font-size:14px;
                        text-transform: capitalize;
                        }
                        
                        :-ms-input-placeholder {
                        color: #b2b9d6;
                        font-size:14px;
                        text-transform: capitalize;
                        }
                        
                        ::placeholder {
                        color: #b2b9d6;
                        font-size:14px;
                        text-transform: capitalize;
                        }
                }

                .patient__phonenumber{
                    position: relative;
                    width: 100%;
                    .country__dropdown{
                        position: absolute;
                        z-index: 99;
                        bottom: 0;
                        left: 50px;
                        ${media.tablet`
                        left:30px;
                        `}
                    .custom__countryselect{
                        position: relative;
                        bottom: 1px;
                        left: 5px;
                        right: 0;
                        width: 55px;
                        height: 36px;
                        border-right: 1px solid #4eb0de;
                        select{
                            font-weight: 600;
                            line-height:normal;
                            cursor: pointer;
                            color: black;
                            font-size: 14px;
                            -webkit-appearance: none;
                            -moz-appearance: none;
                            appearance: none;
                            height: 100%;
                            width: 100%;
                            border: none;
                            padding: 10px;
                            background: transparent;
                            z-index: -1;
                            &:focus{
                                outline:none;
                            }
                        }
                        &:after{
                            content: "";
                            position: absolute;
                            background: url('/images/down-arrow.png') 0 0;
                            background-size: 10px;
                            background-repeat: no-repeat;
                            width: 10px;
                            height: 10px;
                            right: 7px;
                            top: 17px;
                        }
                    }
                }
                .input-phone-box{
                    border: 1px solid #4eb0de;
                    width:75%;
                    margin:auto;
                    padding-left: 65px;
                    border-radius: 4px;
                    position: relative;
                    display: -webkit-box;
                    display: -moz-box;
                    display: -ms-flexbox;
                    display: -webkit-flex;
                    display: flex;
                    -webkit-align-items: center;
                    -webkit-box-align: center;
                    -webkit-flex-align: center;
                    align-items: center;
                    -webkit-justify-content: space-between;
                    justify-content: space-between;
                    input{
                        width:100%;
                        flex-basis:auto;
                        border:0;
                        padding:8px;
                    }
                }
                }

                .option-seperator{
                    color: #000;
                    position: relative;
                    max-width: 160px;
                    margin: auto;
                    font-weight: bold;
                    :after{
                        content: '';
                        background: #000;
                        height: 1px;
                        position: absolute;
                        top: 50%;
                        width: 60px;
                        right: 0;
                    }
                    :before{
                        content: '';
                        background: #000;
                        height: 1px;
                        position: absolute;
                        top: 50%;
                        width: 60px;
                        left: 0;
                    }
                }
            }

            .country-phone{
                max-width: 75%;
                margin: 0 auto;
                .react-tel-input{
                    .form-control{
                        width:100%;
                        border-color:#b2b9d6;
                        height:40px;
                        &:focus{
                            outline:none;
                            box-shadow:none;
                        }
                        ::-webkit-input-placeholder {
                        color: #b2b9d6;
                        font-size:14px;
                        text-transform: capitalize;
                        }
                        
                        :-ms-input-placeholder {
                        color: #b2b9d6;
                        font-size:14px;
                        text-transform: capitalize;
                        }
                        
                        ::placeholder {
                        color: #b2b9d6;
                        font-size:14px;
                        text-transform: capitalize;
                        }
                    }
                }
                .flag-dropdown{
                    background: #fff;
                    border-right:0;
                    .country-list{
                        text-align:left;
                    }
                    .arrow{
                        border:0;
                        background-image:url('/images/down-arrow.png');
                        background-repeat: no-repeat;
                        width: 20px;
                        height: 10px;
                        background-size: 10px;
                        background-position: top center;
                    }
                }
            } 
            .button-action{
                text-align: center;
                   margin: 40px 0;
                .joinbtn{
                    border-radius: 25px;
                    border: none;
                    background: #344177;
                    padding: 8px 40px;
                    padding: 8px 30px;
                    color:#fff;
                    cursor: pointer;
                    min-width: 200px;
                    &:disabled{
                        background:#D5D8E3;
                        font-weight: 600;
                    }
                    &:focus{
                        outline: none;
                    }
                }
            }
        }
        
    }
    .loading-spinner{
        width: 15px !important;
        height: 15px !important;
        margin-right: 10px;
        color: #4eb0de !important;
    }
    .error-msg > .MuiSnackbarContent-root{
        background: #F44335;
        color: white;
    }
}


`;


export default (ParentLoginWrapper);